import QueryHeader from './QueryHeader'

export default QueryHeader
